<template lang="pug">
#tabela-gestao-contrato-originacao-empresa
    .tabela-gestao-contrato-originacao__tabela
        el-table(
            :data='tabelaData',
            v-loading='carregando',
            stripe,
            :default-sort='{ prop: "date", order: "descending" }',
            @sort-change='sortChangeRequest',
            style='width: 100%'
        )
            el-table-column(
                prop='numeroContrato',
                label='Número do contrato',
                align='left'
                width='170'
            )
            el-table-column(
                prop='subEmpresaNome',
                label='Fornecedor'
            )
            el-table-column(
                prop='materialNome',
                label='Cultura',
                width='255',
                sortable
            )
            el-table-column(
                prop='safraNome',
                label='Safra',
                width='75',
                align='right'
            )
            el-table-column(
                prop='volumeContratado',
                label='Volume contratado (t)',
                align='right'
                width='180'
            )
            el-table-column(
                prop='dataContrato',
                label='Data do contrato',
                width='170'
                align='right'
            )
            el-table-column(
                prop='statusEmpresa',
                label='Status',
                sortable
                align='left'
                width='120'
            )
                .template(slot-scope='scope')
                    .status-processamento {{ scope.row.statusEmpresa }}
                    .status-processamento__dias(v-if='scope.row.dataHa')
                        i.mdi.mdi-clock-outline
                        | {{ scope.row.dataHa }}

            el-table-column(label='Ações', align='center', width='80')
                .template.d-flex.justify-content-center.tabela-gestao-icone(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='visualizarProcessamento(scope.row.numeroContrato)'
                            )
                                | Visualizar contrato
                            el-dropdown-item(
                                v-if='scope.row.statusEmpresaCodigo === "CONCLUIDO"',
                                @click.native='exportarRelatorioContrato(scope.row.numeroContrato)'
                            )
                                i.mdi.mdi-file-download-outline
                                span Exportar relatório do contrato
                            el-dropdown-item(
                                @click.native='removerContrato(scope.row.numeroContrato)',
                                v-if='codigosRemover[scope.row.statusEmpresaCodigo]'
                            )
                                i.mdi.mdi-trash-can-outline
                                span Remover contrato
            template(slot='empty')
                el-empty(description='Sem dados')

    .tabela-gestao-contrato-originacao__paginacao
        div
            span.pagina {{ paginacao.total }} contratos
            span.pagina.espacamento-totalizador {{ totalizador }}

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )
</template>

<script>
import ModalDetalheAnalise from '@/components/contratosOriginacao/ModalDetalheAnalise.vue';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import { mapGetters } from 'vuex';
import { connect, subscribe, disconnect } from '@/utils/websocket';

export default {
    name: 'TabelaGestaoContratoOriginacaoEmpresa',
    components: { ModalDetalheAnalise },
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        },
        totalizador: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            notificacaoExportarRelatorio: null,
            codigosRemover: {
                NAO_VISUALIZADO: 'NAO_VISUALIZADO',
                CONCLUIDO: 'CONCLUIDO'
            }
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    methods: {
        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },
        sortChangeRequest(column) {
            this.$emit('ordenarTabela', column);
        },
        visualizarProcessamento(numeroContrato) {
            this.$router.push({
                name: 'VisualizarContratoOriginacaoEmpresa',
                params: { id: numeroContrato }
            });
        },
        async exportarRelatorioContrato(numeroContrato) {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message:
                        'Não foi possível se conectar na api para realizar o download do pdf!'
                });
                return;
            }

            if (this.usuarioLogado) {
                try {
                    subscribe(
                        `${this.usuarioLogado.idKeyCloack}/empresa/relatorio/exportado`,
                        response => {
                            if (response) {
                                const linkSource = `data:application/pdf;base64,${response}`;
                                const link = document.createElement('a');
                                const fileName =
                                    'relatorio-contrato-originacao.pdf';
                                link.href = linkSource;
                                link.download = fileName;
                                document.body.append(link);
                                link.click();
                                link.remove();
                            } else {
                                this.$notify.error({
                                    message:
                                        'Não foi possível exportar o relatório do contrato de originação!'
                                });
                            }
                            if (this.notificacaoExportarRelatorio) {
                                this.notificacaoExportarRelatorio.close();
                            }
                            disconnect();
                        }
                    );

                    ContratoOriginacaoService.exportarRelatorioContratoEmpresa(
                        numeroContrato
                    );

                    this.notificacaoExportarRelatorio = this.$notify({
                        message:
                            '<i class="el-icon-loading" style="font-size: 20px; color: #043c5a;"></i> O download do relatório está sendo processado!',
                        duration: 600000,
                        dangerouslyUseHTMLString: true,
                        showClose: false
                    });
                } catch (error) {
                    this.$notify.error({
                        message: 'Não foi possível exportar o pdf!'
                    });
                    if (this.notificacaoExportarRelatorio) {
                        this.notificacaoExportarRelatorio.close();
                    }
                    disconnect();
                }
            } else {
                this.$notify.error({
                    message: 'Usuário deslogado!'
                });
                disconnect();
            }
        },
        async removerContrato(codContrato) {
            try {
                const result = await this.$messageBox.confirm(
                    `Deseja remover contrato ${codContrato}?`,
                    'Aviso',
                    {
                        confirmButtonText: 'Sim',
                        cancelButtonText: 'Cancelar',
                        type: 'warning'
                    }
                );
                if (result) {
                    this.emiteRemoverContrato(codContrato);
                }
            } catch (error) {
                this.$notify.error({
                    message: 'Erro na requisição de remover contrato.'
                });
            }
        },
        emiteRemoverContrato(codContrato) {
            this.$emit('removerContrato', codContrato);
        }
    }
};
</script>
<style lang="scss">
#tabela-gestao-contrato-originacao-empresa {
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
        thead.has-gutter {
            height: 67px;
            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }
    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }
    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }
    .tabela-gestao-icone {
        i {
            font-size: 27px;
        }
    }
    .status-processamento__dias {
        font-size: 12px;
        font-style: italic;
        i {
            margin-right: 2px;
        }
        .texto-alert {
            columns: #f88342;
        }
    }

    .espacamento-totalizador {
        margin-left: 20px;
    }
}
.el-message-box__btns {
    display: flex;
    justify-content: space-between;
}
</style>
